import { mapFromGlobalDataCache } from 'mappings/globalDataCacheMapping';
import LoginDTO from 'models/dto/loginDTO';
import { IdentityProviderType } from 'models/identityProvider';
import Login from 'models/login';
import { DefLanguageCode } from 'models/setting';
import { fromApiDateTimeOptional } from 'utils/datetime';
import { mapFromTenants } from './tenantMapping';

export function mapFromLogin(loginDTO: LoginDTO): Login {
  const newLogin = new Login();

  newLogin.tenantId = loginDTO.tenantId ?? ''; //can be undefined when tenant is not registered
  newLogin.userId = loginDTO.userId;
  //absent until the API that sends them is deployed: every login is a Microsoft Entra ID login until then
  newLogin.identityProviderType = loginDTO.identityProviderType ?? IdentityProviderType.Entra;
  newLogin.tenantIdentityProviderType = loginDTO.tenantIdentityProviderType ?? IdentityProviderType.Entra;
  newLogin.userSystemRoles = loginDTO.userSystemRoles;
  newLogin.userCustomRoles = loginDTO.userCustomRoles;
  newLogin.permissions = loginDTO.permissions;
  newLogin.lastLogin = fromApiDateTimeOptional(loginDTO.lastLogin);
  newLogin.tenantLicensed = loginDTO.tenantLicensed;
  newLogin.userLicensed = loginDTO.userLicensed;
  newLogin.userLanguageCode = loginDTO.userLanguageCode;
  newLogin.trialStart = fromApiDateTimeOptional(loginDTO.trialStart);
  newLogin.globalDataCache = mapFromGlobalDataCache(loginDTO.globalDataCache);
  newLogin.defLanguageCode = newLogin.globalDataCache.settings.get(DefLanguageCode);
  newLogin.storeMgmtState = loginDTO.storeMgmtState;
  newLogin.subscriptionType = loginDTO.subscriptionType;
  newLogin.leadSource = loginDTO.leadSource;
  newLogin.partnerId = loginDTO.partnerId;
  newLogin.isPartner = loginDTO.isPartner ?? false;
  newLogin.tenants = mapFromTenants(loginDTO.tenants);
  newLogin.isOnboardingInProgress = loginDTO.isOnboardingInProgress;
  newLogin.hasUnfinishedOnboarding = loginDTO.hasUnfinishedOnboarding ?? false;
  newLogin.orgUnitHasSeparateIdentityProvider = loginDTO.orgUnitHasSeparateIdentityProvider ?? false;
  newLogin.isCheckpointPreview = loginDTO.isCheckpointPreview ?? false;

  return newLogin;
}
